module.exports = __webpack_public_path__ + "img/aver.8c64749f.gif";